const PAINTABLE_BRICK_PROVIDER: any = {
  id: 389,
  name: 'Paintable Brick',
};

const PAINTABLE_BRICK_PRODUCT: any = {
  legacy_id: 15481,
  id: 146284,
  name: 'Paintable Brick',
};

const DISCONTINUED_GAF_VARIATION_GROUPS: any = {
  155: {
    legacy_id: 155,
    id: 109679,
    name: 'Camelot',
  },
  265: {
    legacy_id: 265,
    id: 109686,
    name: 'Sienna',
  },
  292: {
    legacy_id: 292,
    id: 109687,
    name: 'Monaco',
  },
};

const DISCONTINUED_CERTAINTEED_VARIATION_GROUPS: any = {
  10469: {
    legacy_id: 10469,
    id: 109291,
    name: 'Half-Round Shingles',
  },
  5402: {
    legacy_id: 5402,
    id: 109453,
    name: 'Double 4 ½" Rough Cedar Dutchlap',
  },
  5164: {
    legacy_id: 5164,
    id: 109365,
    name: 'CT20',
  },
};

const DISCONTINUED_CERTAINTEED_VARIATIONS: any = {
  5589: {
    legacy_id: 5589,
    id: 1776619,
    name: 'Bermuda Blue',
  },
  5599: {
    legacy_id: 5599,
    id: 1776629,
    name: 'Green Tea',
  },
  5616: {
    legacy_id: 5616,
    id: 1776646,
    name: 'Silver Ash',
  },
  5620: {
    legacy_id: 5620,
    id: 1776650,
    name: 'Suede',
  },
  5621: {
    legacy_id: 5621,
    id: 1776651,
    name: 'Terra Cotta',
  },
  5690: {
    legacy_id: 5690,
    id: 1776531,
    name: 'Canyon Blend',
  },
  5692: {
    legacy_id: 5692,
    id: 1776533,
    name: 'Glacier Blend',
  },
  5693: {
    legacy_id: 5693,
    id: 1776534,
    name: 'Meadow Blend',
  },
  5689: {
    legacy_id: 5689,
    id: 1776530,
    name: 'Arctic Blend',
  },
  5694: {
    legacy_id: 5694,
    id: 1776535,
    name: 'Timber Blend',
  },
  5660: {
    legacy_id: 5660,
    id: 1776574,
    name: 'Silver Ash',
  },
  5697: {
    legacy_id: 5697,
    id: 1776539,
    name: 'Canyon Blend',
  },
  5699: {
    legacy_id: 5699,
    id: 1776541,
    name: 'Glacier Blend',
  },
  5700: {
    legacy_id: 5700,
    id: 1776542,
    name: 'Meadow Blend',
  },
  5696: {
    legacy_id: 5696,
    id: 1776538,
    name: 'Arctic Blend',
  },
  5701: {
    legacy_id: 5701,
    id: 1776543,
    name: 'Timber Blend',
  },
  5654: {
    legacy_id: 5654,
    id: 1776607,
    name: 'Silver Ash',
  },
  5765: {
    legacy_id: 5765,
    id: 1776688,
    name: 'Silver Ash',
  },
  6208: {
    legacy_id: 6208,
    id: 1780073,
    name: 'Silver Ash',
  },
  6109: {
    legacy_id: 6109,
    id: 1779991,
    name: 'Silver Ash',
  },
  6113: {
    legacy_id: 6113,
    id: 1779995,
    name: 'Suede',
  },
  6157: {
    legacy_id: 6157,
    id: 1780045,
    name: 'Silver Ash',
  },
  6161: {
    legacy_id: 6161,
    id: 1780046,
    name: 'Suede',
  },
  6133: {
    legacy_id: 6133,
    id: 1780086,
    name: 'Silver Ash',
  },
  1916: {
    legacy_id: 1916,
    id: 1775866,
    name: 'Light Maple',
  },
  1912: {
    legacy_id: 1912,
    id: 1775875,
    name: 'Terra Cotta',
  },
  5723: {
    legacy_id: 5723,
    id: 1775880,
    name: 'Heritage Cream',
  },
  10615: {
    legacy_id: 10615,
    id: 1776751,
    name: 'Terra Cotta',
  },
  10510: {
    legacy_id: 10510,
    id: 1776765,
    name: 'Autumn Yellow',
  },
  10536: {
    legacy_id: 10536,
    id: 1776771,
    name: 'Terra Cotta',
  },
  10587: {
    legacy_id: 10587,
    id: 1776707,
    name: 'Terra Cotta',
  },
  10643: {
    legacy_id: 10643,
    id: 1776822,
    name: 'Terra Cotta',
  },
  6137: {
    legacy_id: 6137,
    id: 1780103,
    name: 'Suede',
  },
  6181: {
    legacy_id: 6181,
    id: 1780016,
    name: 'Silver Ash',
  },
  6185: {
    legacy_id: 6185,
    id: 1780022,
    name: 'Suede',
  },
  6190: {
    legacy_id: 6190,
    id: 1780058,
    name: 'Heritage Cream',
  },
  6191: {
    legacy_id: 6191,
    id: 1780061,
    name: 'Light Maple',
  },
  6197: {
    legacy_id: 6197,
    id: 1780065,
    name: 'Snow',
  },
  6193: {
    legacy_id: 6193,
    id: 1780063,
    name: 'Oxford Blue',
  },
  6196: {
    legacy_id: 6196,
    id: 1780069,
    name: 'Silver Ash',
  },
  5819: {
    legacy_id: 5819,
    id: 1776244,
    name: 'Suede',
  },
  5799: {
    legacy_id: 5799,
    id: 1776229,
    name: 'Suede',
  },
  5800: {
    legacy_id: 5800,
    id: 1776238,
    name: 'Terra Cotta',
  },
  5782: {
    legacy_id: 5782,
    id: 1776216,
    name: 'Desert Tan',
  },
  5787: {
    legacy_id: 5787,
    id: 1776228,
    name: 'Heritage Cream',
  },
  5789: {
    legacy_id: 5789,
    id: 1776222,
    name: 'Light Maple',
  },
  5792: {
    legacy_id: 5792,
    id: 1776233,
    name: 'Oxford Blue',
  },
  5846: {
    legacy_id: 5846,
    id: 1776265,
    name: 'Desert Tan',
  },
  5848: {
    legacy_id: 5848,
    id: 1776269,
    name: 'Heritage Cream',
  },
  5850: {
    legacy_id: 5850,
    id: 1776270,
    name: 'Light Maple',
  },
  5852: {
    legacy_id: 5852,
    id: 1776274,
    name: 'Oxford Blue',
  },
  4943: {
    legacy_id: 4943,
    id: 1779961,
    name: 'Terracotta',
  },
  4944: {
    legacy_id: 4944,
    id: 1779962,
    name: 'Tudor Brown',
  },
  4991: {
    legacy_id: 4991,
    id: 1779692,
    name: 'Max Def Burnt Sienna',
  },
  4989: {
    legacy_id: 4989,
    id: 1779704,
    name: 'Max Def Heather Blend',
  },
  4987: {
    legacy_id: 4987,
    id: 1779715,
    name: 'Max Def Resawn Shake',
  },
  4972: {
    legacy_id: 4972,
    id: 1779707,
    name: 'Mist White',
  },
  4978: {
    legacy_id: 4978,
    id: 1779720,
    name: 'Terra Cotta',
  },
  5175: {
    legacy_id: 5175,
    id: 1779675,
    name: 'Max Def Cobblestone',
  },
  5178: {
    legacy_id: 5178,
    id: 1779670,
    name: 'Max Def Georgetown Gray',
  },
  5183: {
    legacy_id: 5183,
    id: 1779678,
    name: 'Max Def Shenandoah',
  },
  5187: {
    legacy_id: 5187,
    id: 1779733,
    name: 'Max Def Birchwood',
  },
  5004: {
    legacy_id: 5004,
    id: 1779744,
    name: 'Max Def Granite Gray',
  },
  4994: {
    legacy_id: 4994,
    id: 1779747,
    name: 'Max Def Mission Brown',
  },
  5026: {
    legacy_id: 5026,
    id: 1779757,
    name: 'Mauna Loa',
  },
  5029: {
    legacy_id: 5029,
    id: 1779763,
    name: 'Sedona',
  },
  5035: {
    legacy_id: 5035,
    id: 1779657,
    name: 'Max Def Resawn Shake',
  },
  5039: {
    legacy_id: 5039,
    id: 1779655,
    name: 'Santa Fe',
  },
  5042: {
    legacy_id: 5042,
    id: 1779724,
    name: 'Aged Bark',
  },
  5043: {
    legacy_id: 5043,
    id: 1779726,
    name: 'Chestnut',
  },
  5048: {
    legacy_id: 5048,
    id: 1779730,
    name: 'Old Overton',
  },
  5077: {
    legacy_id: 5077,
    id: 1778326,
    name: 'Colonial Slate',
  },
  5076: {
    legacy_id: 5076,
    id: 1778327,
    name: 'Driftwood',
  },
  5110: {
    legacy_id: 5110,
    id: 1778295,
    name: 'Autumn Brown',
  },
  5112: {
    legacy_id: 5112,
    id: 1778297,
    name: 'Black Pepper',
  },
  5116: {
    legacy_id: 5116,
    id: 1778301,
    name: 'Cobblestone Gray',
  },
  5117: {
    legacy_id: 5117,
    id: 1778302,
    name: 'Colonial Slate',
  },
  5118: {
    legacy_id: 5118,
    id: 1778303,
    name: 'Coral Frost',
  },
  5126: {
    legacy_id: 5126,
    id: 1778311,
    name: 'Maple Red Blend',
  },
  5131: {
    legacy_id: 5131,
    id: 1778316,
    name: 'Pewter',
  },
  5133: {
    legacy_id: 5133,
    id: 1778318,
    name: 'Sandalwood',
  },
  5134: {
    legacy_id: 5134,
    id: 1778319,
    name: 'Silver Birch',
  },
};

const DISCONTINUED_PLYGEM_PRODUCTS: any = {
  10157: {
    legacy_id: 10157,
    id: 145175,
    name: 'Napco - American Accents',
  },
  10849: {
    legacy_id: 10849,
    id: 145236,
    name: 'Napco - Cedar Select',
  },
  10154: {
    legacy_id: 10154,
    id: 145192,
    name: 'Napco - American 76',
  },
  10155: {
    legacy_id: 10155,
    id: 145191,
    name: 'Napco - American Comfort',
  },
  10847: {
    legacy_id: 10847,
    id: 145215,
    name: 'Napco - American Essence',
  },
  10848: {
    legacy_id: 10848,
    id: 145228,
    name: 'Napco - American Splendor',
  },
};

const DISCONTINUED_MASTIC_VARIATIONS: any = {
  13013: {
    legacy_id: 13013,
    id: 1777039,
    name: 'American Walnut',
  },
  12989: {
    legacy_id: 12989,
    id: 1777017,
    name: 'Autumn Harvest',
  },
  12987: {
    legacy_id: 12987,
    id: 1777015,
    name: 'Brandy Wood',
  },
  13005: {
    legacy_id: 13005,
    id: 1777033,
    name: 'Cape Cod Grey',
  },
  13006: {
    legacy_id: 13006,
    id: 1777034,
    name: 'Cedar',
  },
  12969: {
    legacy_id: 12969,
    id: 1776997,
    name: 'Deep Cavern',
  },
  12971: {
    legacy_id: 12971,
    id: 1776999,
    name: 'Deep Granite',
  },
  12990: {
    legacy_id: 12990,
    id: 1777018,
    name: 'Mahogany',
  },
  12995: {
    legacy_id: 12995,
    id: 1777023,
    name: 'Misty Shadow',
  },
  12988: {
    legacy_id: 12988,
    id: 1777016,
    name: 'Montana Suede',
  },
  12973: {
    legacy_id: 12973,
    id: 1777001,
    name: 'Natural Slate',
  },
  13003: {
    legacy_id: 13003,
    id: 1777031,
    name: 'Newport Bay',
  },
  12991: {
    legacy_id: 12991,
    id: 1777019,
    name: 'Red Brick',
  },
  13008: {
    legacy_id: 13008,
    id: 1777036,
    name: 'Red Cedar',
  },
  12993: {
    legacy_id: 12993,
    id: 1777021,
    name: 'Russet Red',
  },
  13004: {
    legacy_id: 13004,
    id: 1777032,
    name: 'Terra Cotta',
  },
  13009: {
    legacy_id: 13009,
    id: 1777037,
    name: 'Timber',
  },
  13011: {
    legacy_id: 13011,
    id: 1777038,
    name: 'Timberstone',
  },
  13000: {
    legacy_id: 13000,
    id: 1777028,
    name: 'Vineyard Grove',
  },
  13007: {
    legacy_id: 13007,
    id: 1777035,
    name: 'Walnut',
  },
  12970: {
    legacy_id: 12970,
    id: 1776998,
    name: 'Whispering Timber',
  },
  12947: {
    legacy_id: 12947,
    id: 1777106,
    name: 'Brandy Wood',
  },
  12967: {
    legacy_id: 12967,
    id: 1777126,
    name: 'Cedar',
  },
  12929: {
    legacy_id: 12929,
    id: 1777088,
    name: 'Deep Cavern',
  },
  12950: {
    legacy_id: 12950,
    id: 1777109,
    name: 'Mahogany',
  },
  12933: {
    legacy_id: 12933,
    id: 1777092,
    name: 'Natural Slate',
  },
  12963: {
    legacy_id: 12963,
    id: 1777122,
    name: 'Newport Bay',
  },
  12951: {
    legacy_id: 12951,
    id: 1777110,
    name: 'Red Brick',
  },
  12968: {
    legacy_id: 12968,
    id: 1777127,
    name: 'Red Cedar',
  },
  12965: {
    legacy_id: 12965,
    id: 1777124,
    name: 'Terra Cotta',
  },
  13010: {
    legacy_id: 13010,
    id: 1777128,
    name: 'Timber',
  },
  12930: {
    legacy_id: 12930,
    id: 1777089,
    name: 'Whispering Timber',
  },
  12907: {
    legacy_id: 12907,
    id: 1777149,
    name: 'Brandy Wood',
  },
  12928: {
    legacy_id: 12928,
    id: 1777170,
    name: 'Cedar',
  },
  12889: {
    legacy_id: 12889,
    id: 1777131,
    name: 'Deep Cavern',
  },
  12910: {
    legacy_id: 12910,
    id: 1777152,
    name: 'Mahogany',
  },
  12893: {
    legacy_id: 12893,
    id: 1777135,
    name: 'Natural Slate',
  },
  12923: {
    legacy_id: 12923,
    id: 1777165,
    name: 'Newport Bay',
  },
  12911: {
    legacy_id: 12911,
    id: 1777153,
    name: 'Red Brick',
  },
  12927: {
    legacy_id: 12927,
    id: 1777169,
    name: 'Red Cedar',
  },
  12926: {
    legacy_id: 12926,
    id: 1777168,
    name: 'Timber',
  },
  12890: {
    legacy_id: 12890,
    id: 1777132,
    name: 'Whispering Timber',
  },
  8921: {
    legacy_id: 8921,
    id: 1777554,
    name: 'Lakeshore Fern',
  },
  8918: {
    legacy_id: 8918,
    id: 1777573,
    name: 'Portsmouth Blue',
  },
  8914: {
    legacy_id: 8914,
    id: 1777583,
    name: 'Timberstone',
  },
  8927: {
    legacy_id: 8927,
    id: 1777560,
    name: 'Vineyard Grove',
  },
  12810: {
    legacy_id: 12810,
    id: 1778414,
    name: 'Brandy Wood',
  },
  12799: {
    legacy_id: 12799,
    id: 1778403,
    name: 'Corn Silk',
  },
  12814: {
    legacy_id: 12814,
    id: 1778418,
    name: 'Deep Granite',
  },
  12812: {
    legacy_id: 12812,
    id: 1778416,
    name: 'English Wedgewood',
  },
  12809: {
    legacy_id: 12809,
    id: 1778413,
    name: 'Mahogany',
  },
  12808: {
    legacy_id: 12808,
    id: 1778412,
    name: 'Natural Slate',
  },
  12807: {
    legacy_id: 12807,
    id: 1778411,
    name: 'Newport Bay',
  },
  12811: {
    legacy_id: 12811,
    id: 1778415,
    name: 'Quiet Willow',
  },
  12806: {
    legacy_id: 12806,
    id: 1778410,
    name: 'Red Brick',
  },
  12813: {
    legacy_id: 12813,
    id: 1778417,
    name: 'Rugged Canyon',
  },
  8242: {
    legacy_id: 8242,
    id: 1781256,
    name: 'Timberstone',
  },
  3768: {
    legacy_id: 3768,
    id: 1781246,
    name: 'Yellow',
  },
  12733: {
    legacy_id: 12733,
    id: 1781327,
    name: 'Deep Cavern',
  },
  8239: {
    legacy_id: 8239,
    id: 1781322,
    name: 'Timberstone',
  },
  12759: {
    legacy_id: 12759,
    id: 1781323,
    name: 'Whispering Timber',
  },
  3912: {
    legacy_id: 3912,
    id: 1781398,
    name: 'Colonial Yellow',
  },
  12737: {
    legacy_id: 12737,
    id: 1781403,
    name: 'Deep Cavern',
  },
  8243: {
    legacy_id: 8243,
    id: 1781396,
    name: 'Timberstone',
  },
  12763: {
    legacy_id: 12763,
    id: 1781397,
    name: 'Whispering Timber',
  },
  8244: {
    legacy_id: 8244,
    id: 1781440,
    name: 'Timberstone',
  },
  8245: {
    legacy_id: 8245,
    id: 1781473,
    name: 'Timberstone',
  },
  3684: {
    legacy_id: 3684,
    id: 1781880,
    name: 'Colonial Yellow',
  },
  12734: {
    legacy_id: 12734,
    id: 1781883,
    name: 'Deep Cavern',
  },
  8240: {
    legacy_id: 8240,
    id: 1781876,
    name: 'Timberstone',
  },
  12760: {
    legacy_id: 12760,
    id: 1781877,
    name: 'Whispering Timber',
  },
  12735: {
    legacy_id: 12735,
    id: 1781928,
    name: 'Deep Cavern',
  },
  8241: {
    legacy_id: 8241,
    id: 1781943,
    name: 'Timberstone',
  },
  12761: {
    legacy_id: 12761,
    id: 1781945,
    name: 'Whispering Timber',
  },
  12751: {
    legacy_id: 12751,
    id: 1783999,
    name: 'Deep Cavern',
  },
  8477: {
    legacy_id: 8477,
    id: 1784005,
    name: 'Timberstone',
  },
  203: {
    legacy_id: 203,
    id: 1784046,
    name: 'Lakeshore Fern',
  },
  200: {
    legacy_id: 200,
    id: 1784035,
    name: 'Portsmouth Blue',
  },
  8237: {
    legacy_id: 8237,
    id: 1784027,
    name: 'Timberstone',
  },
  723: {
    legacy_id: 723,
    id: 1784045,
    name: 'Vineyard Grove',
  },
  12757: {
    legacy_id: 12757,
    id: 1784054,
    name: 'Whispering Timber',
  },
  910: {
    legacy_id: 910,
    id: 1784085,
    name: 'Brandy Wood',
  },
  12750: {
    legacy_id: 12750,
    id: 1784056,
    name: 'Deep Cavern',
  },
  926: {
    legacy_id: 926,
    id: 1784082,
    name: 'Mahogany',
  },
  909: {
    legacy_id: 909,
    id: 1784061,
    name: 'Natural Slate',
  },
  933: {
    legacy_id: 933,
    id: 1784071,
    name: 'Newport Bay',
  },
  915: {
    legacy_id: 915,
    id: 1784083,
    name: 'Red Brick',
  },
  8259: {
    legacy_id: 8259,
    id: 1784064,
    name: 'Timberstone',
  },
  12783: {
    legacy_id: 12783,
    id: 1784084,
    name: 'Whispering Timber',
  },
  12753: {
    legacy_id: 12753,
    id: 1784111,
    name: 'Deep Cavern',
  },
  1040: {
    legacy_id: 1040,
    id: 1784113,
    name: 'Harbor Grey',
  },
  1023: {
    legacy_id: 1023,
    id: 1784114,
    name: 'Victorian Grey',
  },
  8262: {
    legacy_id: 8262,
    id: 1784115,
    name: 'Timberstone',
  },
  1028: {
    legacy_id: 1028,
    id: 1784116,
    name: 'Sandstone',
  },
  1027: {
    legacy_id: 1027,
    id: 1784117,
    name: 'Desert Sand',
  },
  1024: {
    legacy_id: 1024,
    id: 1784118,
    name: 'Wicker',
  },
  1021: {
    legacy_id: 1021,
    id: 1784119,
    name: 'Pebblestone Clay',
  },
  1037: {
    legacy_id: 1037,
    id: 1784120,
    name: 'Everest',
  },
  11541: {
    legacy_id: 11541,
    id: 1784121,
    name: 'English Wedgewood',
  },
  1009: {
    legacy_id: 1009,
    id: 1784122,
    name: 'Classic Cream',
  },
  1029: {
    legacy_id: 1029,
    id: 1784123,
    name: 'Cameo',
  },
  1019: {
    legacy_id: 1019,
    id: 1784124,
    name: 'Scottish Thistle',
  },
  1034: {
    legacy_id: 1034,
    id: 1784125,
    name: 'Quiet Willow',
  },
  1036: {
    legacy_id: 1036,
    id: 1784126,
    name: 'Sage',
  },
  1017: {
    legacy_id: 1017,
    id: 1784127,
    name: 'Rugged Canyon',
  },
  1013: {
    legacy_id: 1013,
    id: 1784128,
    name: 'Montana Suede',
  },
  12785: {
    legacy_id: 12785,
    id: 1784129,
    name: 'Whispering Timber',
  },
  145: {
    legacy_id: 145,
    id: 1784200,
    name: 'Utility Air Vent',
  },
};

const DISCONTINUED_MASTIC_PRODUCTS: any = {
  4007: {
    legacy_id: 4007,
    id: 145343,
    name: 'Steel 10in Board&Batten Siding',
  },
  3605: {
    legacy_id: 3605,
    id: 145350,
    name: 'carved',
  },
  938: {
    legacy_id: 938,
    id: 145464,
    name: '6” Horizontal Siding',
  },
};

export default {
  DISCONTINUED_CERTAINTEED_VARIATIONS,
  DISCONTINUED_CERTAINTEED_VARIATION_GROUPS,
  DISCONTINUED_GAF_VARIATION_GROUPS,
  DISCONTINUED_MASTIC_PRODUCTS,
  DISCONTINUED_MASTIC_VARIATIONS,
  DISCONTINUED_PLYGEM_PRODUCTS,
  PAINTABLE_BRICK_PRODUCT,
  PAINTABLE_BRICK_PROVIDER,
};
